export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=40456f9f92e29dbcf90ac3600348bac05c7b76d037&name=addToFolderEventAction!'